var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBenefitPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 250,
    viewBox: "0 0 300 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300 0H0V250H300V0Z",
    fill: "#3EC6FF",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251 54.2843C251 50.2603 247.883 47 244.038 47H55.9616C52.1168 47 49 50.2603 49 54.2843V195.72C49 199.74 52.1168 203 55.9616 203H244.037C247.882 203 250.999 199.74 250.999 195.72V54.2843H251Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.5 122C111.717 122 120 113.27 120 102.502C120 91.7303 111.717 83 101.5 83C91.2826 83 83 91.7303 83 102.502C83 113.27 91.2826 122 101.5 122Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93 203L153.6 113.651L178.656 149.037L210.881 96L251 157.064",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitPlaceholder);
export default __webpack_public_path__ + "static/media/benefit_placeholder.4a547da292f972a9622e8a0ae7ba5530.svg";
export { ForwardRef as ReactComponent };